// 通讯录
import PageAddress from './PageAddress';

const router = {
  path: 'resource',
  breadcrumbName: '公共资源',
  childRoutes: [
    {
      path: 'address',
      breadcrumbName: '公司通讯录',
      indexRoute: { component: PageAddress },
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/resource/router.js